<div class="d-md-flex mg-b40">
  <div class class="col-left">
    <div class="f-item color-s2 counter mg-f-item1">
      <div class="counter-box bg-s2 d-flex justify-content-center align-items-center">
        <a href="mailto:lizcespedes0326@gmail.com" class="bg-s3"><i class="fa fa-google" aria-hidden="true"></i></a>
      </div>
    </div>
    <div class="f-item color-s3 counter mg-f-item2">
      <div class="counter-box bg-s2 d-flex justify-content-center align-items-center">
        <a href="https://www.linkedin.com/in/naeliza/" class="bg-s1"><i class="fa fa-linkedin"
            aria-hidden="true"></i></a>
      </div>
    </div>
  </div>

  <div class="col-right">
    <div class="f-item color-s4 counter mg-f-item3">
      <div class="counter-box bg-s2 d-flex justify-content-center align-items-center">

        <a href="https://github.com/Naeliza" class="bg-s4"><i class="fa fa-github" aria-hidden="true"></i></a>
      </div>
    </div>
  </div>
</div>

<div class="btn-contact bg-s2 text-center">
  <h4 class="title color-d11">Get a project? Let’s talk.</h4>
  <a href="mailto:lizcespedes0326@gmail.com" class="email color-s2 color-d15">lizcespedes0326@gmail.com</a>
</div>
